import React from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';

export const NEIGHBOR_SCAN_BATCH_OPTIONS = [0, 1, 2, 3, 5, 10, 20];

/** Default batch size for neighbors scans started from the UI. */
export const DEFAULT_NEIGHBOR_SCAN_BATCH = 5;

export function describeNeighborScanBatch(batchSize) {
  const n = Number(batchSize) || 0;
  if (n <= 0) return 'All devices scan at the same time.';
  return `${n} device${n === 1 ? '' : 's'} scan at a time; the rest wait their turn.`;
}

/**
 * "Devices scanning at once" for a neighbors scan. While a device scans
 * its radios leave their channels, so neighbours scanning together can
 * miss each other: smaller batches give fuller reports and spread the
 * load. The backend sends the command to the next device whenever one
 * reports, reaches its deadline, or does not confirm the command.
 */
export default function NeighborScanBatchField({ value, onChange, size = 'small', fullWidth = true, sx }) {
  const n = Number(value) || 0;
  return (
    <FormControl size={size} fullWidth={fullWidth} sx={sx}>
      <InputLabel>Devices scanning at once</InputLabel>
      <Select label="Devices scanning at once" value={n} onChange={(e) => onChange(Number(e.target.value))}>
        {NEIGHBOR_SCAN_BATCH_OPTIONS.map((opt) => (
          <MenuItem key={opt} value={opt}>{opt === 0 ? 'All at once' : `${opt} at a time`}</MenuItem>
        ))}
      </Select>
      <FormHelperText>
        {describeNeighborScanBatch(n)} Scanning devices go quiet and can miss each other, so smaller batches give fuller
        neighbour lists. The next device starts when one finishes, times out, or does not confirm the command.
      </FormHelperText>
    </FormControl>
  );
}
